import React from "react";
import { useSelector } from "react-redux";
// Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react";
// // Import Swiper styles
// import "swiper/css";
import "./slider-home.css";

const SliderHome = ({Raised,Goal,ShowFundsRaised}) => {

  const Auth = useSelector((state) => state.Auth);

  //   useEffect(() => {}, []);
  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    currency: "USD",
  });
  return (
    <div className="sl-home container">
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-ride="carousel"
        data-interval="3000"
      >
        
        <div className="carousel-inner">
          <div className="carousel-item active">
            {Auth.auctionData && Auth.auctionData?.WebsiteBanner != null && <img
              className="d-block w-100"
              src={
                Auth.auctionData?.WebsiteBanner != null
                  ? Auth.auctionData?.WebsiteBanner.Url
                  : "/assets/images/Banner_ComingSoon.jpg"
              }
              alt=""
            />}

            {Auth.auctionData && Auth.auctionData?.WebsiteBanner == null && <img
              className="d-block w-100 no-img"
              src="/assets/images/Banner_ComingSoon.jpg"
              alt=""
            />}
           
          </div>          
        </div>        
      </div>


      {ShowFundsRaised && 
      <div className="inner">
        <div className="row row-fix justify-content-md-center">        
        <div className="col-md-4 col-lg-3 group-counter bg-white shadow-lg py-2 offSetCounter border-radius-3">
            {/* <!-- Linear progress bar--> */}

            
              <div className="progress-linear animated cs">
              <div className="progress-header">
                <p>
                  {"$"+formatter.format(Raised)} <span>raised</span>
                </p>                
              </div>
              <div className="progress-bar-linear-wrap">
                <div
                  className="progress-bar-linear"
                  style={{ width: Raised < Goal ? (Raised*100/Goal)+"%" : "100%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>      
}

{!ShowFundsRaised && <div className="no-funds-raised-spacer"></div>}

    </div>
      
  );
};

export default SliderHome;
